import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import './i18n';
import './index.css';
import App from './App';
import { initLandingTrack } from './utils/landingTrack';
import { isPreviewFrame } from './preview/frame';

function render() {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
}

// Кабинет внутри ролика /preview/cabinet: заглушка API вместо бэкенда,
// без трекинга лендинга.
if (isPreviewFrame()) {
  import('./preview/mockApi').then(({ installPreviewMocks }) => {
    installPreviewMocks();
    render();
  });
} else {
  initLandingTrack();
  render();
}
